export const mockTestimonials = [
  {
    name: "Sarah M.",
    location: "Sydney, NSW",
    text: "I started with $3,000 and now I'm building my property deposit faster than I expected. The professional management gives me peace of mind."
  },
  {
    name: "James C.",
    location: "Melbourne, VIC",
    text: "As someone new to investing, SimpleInvest made everything so easy. No jargon, just clear information and transparent fees."
  },
  {
    name: "Emma R.",
    location: "Brisbane, QLD",
    text: "The app is brilliant! I can check my portfolio anytime and the Franklin Templeton backing makes me feel secure about my investment savings."
  },
  {
    name: "Michael O.",
    location: "Perth, WA",
    text: "The education in the app made everything click. I felt way more confident choosing where to invest. Setup was quick - I was investing that same day."
  },
  {
    name: "Lisa P.",
    location: "Adelaide, SA",
    text: "I'm growing my safety net for my family's future. The diversified portfolios and expert management take the stress out of investing."
  },
  {
    name: "David T.",
    location: "Canberra, ACT",
    text: "My SMSF has never been easier to manage. SimpleInvest delivers professional results without the complexity."
  }
];

export const features = [
  {
    icon: "TrendingUp",
    title: "Professionally Managed Portfolios",
    description: "Powered by Franklin Templeton's multi-asset funds with decades of investment expertise."
  },
  {
    icon: "Shield",
    title: "Low & Transparent Fees",
    description: "No hidden charges or surprise costs. Know exactly what you're paying from day one."
  },
  {
    icon: "Smartphone",
    title: "Mobile & Online Access",
    description: "Monitor your investments anytime, anywhere via our intuitive app and online portal."
  },
  {
    icon: "Clock",
    title: "Instant Setup",
    description: "Quick online onboarding with no paperwork. Start investing in minutes, not days."
  }
];

export const howItWorksSteps = [
  {
    number: "01",
    title: "Register",
    description: "Create your account in minutes with our simple online registration process."
  },
  {
    number: "02",
    title: "Select",
    description: "Choose a portfolio that aligns with your investment goals and risk tolerance."
  },
  {
    number: "03",
    title: "Open",
    description: "Complete your application and fund your account to start investing immediately."
  },
  {
    number: "04",
    title: "Monitor",
    description: "Track your portfolio's performance anytime through our app or online portal."
  }
];

export const audienceSegments = [
  {
    icon: "Home",
    title: "Saving for a home",
    description: "Build your property deposit faster with professionally managed, diversified portfolios designed for growth."
  },
  {
    icon: "Users",
    title: "Saving for your kids future",
    description: "Invest in your children's future with flexible investment options that grow alongside your family's needs."
  },
  {
    icon: "Umbrella",
    title: "Growing a safety net",
    description: "Create financial security for your family with low-risk investment options and transparent management."
  },
  {
    icon: "PiggyBank",
    title: "Retirement / SMSF",
    description: "Secure your retirement with expert-managed funds backed by Franklin Templeton's proven track record."
  }
];
